import type { useAgentsOptions } from '@ui/hooks/api/useAgents';
import { create } from 'zustand';

interface AgentsViewStore {
  isGraduated: useAgentsOptions['isGraduated'];
  sortBy: useAgentsOptions['sortBy'];
  search: string;
  isSearchInputShown: boolean;
}

export const useAgentsView = create<AgentsViewStore>(() => ({
  isGraduated: null,
  sortBy: 'created_at',
  search: '',
  isSearchInputShown: false,
}));
